import { render, staticRenderFns } from "./TuSeguroLeads.vue?vue&type=template&id=25627c58"
import script from "./TuSeguroLeads.vue?vue&type=script&lang=js"
export * from "./TuSeguroLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports